export default "__VITE_ASSET__BtAI0Bei__"